export class Accordion {

    constructor(element) {
        this.config = {
            'wrapper': element
        };
        this.active = '';
        this.init();
    }


    init() {
        let _this = this;
        let item = $(this.config.wrapper);
        let wrap = item.find('[data-a-toggle-target]');
        let toggles = item.find('[data-a-toggle]');

        toggles.on('click', function (e) {
            let toggle = $(e.target).closest('[data-a-toggle]');
            let div = item.find(`[data-a-toggle-target="${toggle.data('aToggle')}"]`);

            if (_this.active === div.data('aToggleTarget')) {
                _this.active = null;
                div.slideUp();
                toggle.removeClass('is-open');
            } else {
                _this.active = div.data('aToggleTarget');

                wrap.slideUp();
                div.slideDown();

                toggles.removeClass('is-open');
                toggle.addClass('is-open');
            }
        });

        wrap.each(function (key, itemWrap) {
            if (key === 0) {
                _this.active = itemWrap.dataset.aToggleTarget;
                // add class is-open to the first toggle
                toggles.eq(0).addClass('is-open');
            }
            if (key !== 0) {
                $(itemWrap).hide();
            }
        });
    }


}
